import type { PatientStatusBlock } from '../../../../services/patientCard';
import { useStatusCatalog } from '../../../../services/statusCatalog';
import { Card, StatusBadge } from '../shared';

interface StatusCardProps {
    status: PatientStatusBlock | undefined;
}

function StatusCard({ status }: StatusCardProps) {
    const catalog = useStatusCatalog();
    const internalStatus = status?.internalCaseStatus
        ? catalog.display(status.internalCaseStatus)
        : null;
    const phase = status?.internalCaseStatus
        ? (catalog.meta(status.internalCaseStatus)?.phase ?? null)
        : null;
    return (
        <Card title="Status">
            <div className="grid grid-cols-2 gap-x-4 gap-y-4 h-full content-evenly">
                <StatusBadge label="Phase" value={phase} />
                <StatusBadge label="Internal status" value={internalStatus} />
                <StatusBadge label="External status" value={status?.caseStatus ?? null} />
                <StatusBadge label="Action required" value={status?.actionRequired ?? null} />
            </div>
        </Card>
    );
}

export { StatusCard };
